// extracted by mini-css-extract-plugin
export var aircallIframe = "_f5-3";
export var fabContainer = "_f5-5";
export var fabRinging = "_f5-6";
export var loadingOverlay = "_f5-4";
export var pulse = "_f5-7";
export var widgetContent = "_f5-2";
export var widgetPanel = "_f5-0";
export var widgetPanelExpanded = "_f5-1";